//libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

//icons
import GiftCard from '@nykaa/ui-components/Icons/gift-card';
import NykaaNHeart from '@nykaa/ui-components/Icons/nykaa-n-heart';
import Box from '@nykaa/ui-components/Icons/box';
import Heart from '@nykaa/ui-components/Icons/heart';
import Coupon from '@nykaa/ui-components/Icons/coupon';
import Chat from '@nykaa/ui-components/Icons/chat';
import Help from '@nykaa/ui-components/Icons/help';
import User from '@nykaa/ui-components/Icons/user';
import Document from '@nykaa/ui-components/Icons/document';
import PrivacyPolicy from '@nykaa/ui-components/Icons/privacy-policy';
import CircleLock from '@nykaa/ui-components/Icons/circle-lock';
import AddressBook from '@nykaa/ui-components/Icons/address-book';
import ShippingNReturns from 'shared/svg/ShippingNReturns';
import NykaaNLogo from '@nykaa/ui-components/Icons/nykaa-n-logo';
import TrashCan from '@nykaa/ui-components/Icons/trash-can';
import AboutUs from 'shared/svg/AboutUs';

// hooks
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';

// types
import { Theme } from '@nykaa/ui-components/themes/types';

//constants
import { LOCKED_ICON } from './components/MyAccountSections/constants';

interface SvgsProps {
  name: string;
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const LockIcon = styled(CircleLock)`
  path {
    fill: ${({ theme }) => theme.colors.textDisabled};
  }
`;

function Svgs({ name, ...rest }: SvgsProps) {
  const theme: Theme = useTheme();

  if (name === 'ORDERS') return <Box />;
  if (name === 'WISHLIST') return <Heart />;
  if (name === 'MY_NYKAA_FASHION') return <NykaaNHeart />;
  if (name === 'REWARDS') return <Coupon />;
  if (name === 'MY_GIFT_CARDS') return <GiftCard />;
  if (name === 'CHAT_WITH_US') return <Chat />;
  if (name === 'HELP_CENTER') return <Help />;
  if (name === 'PROFILE') return <User />;
  if (name === 'SHIPPING_POLICY') return <ShippingNReturns {...rest} className="shipping-icon" />;
  if (name === 'ABOUT_US') return <AboutUs {...rest} />;
  if (name.includes('PRIVACY_POLICY')) return <PrivacyPolicy color="white" />;
  if (name === LOCKED_ICON) return <LockIcon />;
  if (name === 'ADDRESS_BOOK') return <AddressBook />;
  if (name === 'ONR') return <NykaaNLogo />;
  if (name === 'COUPON') return <Coupon />;
  if (name === 'TERMS_AND_CONDITIONS' || name === 'RESPONSIBLE_DISCLOSURE')
    return <Document color="white" />;
  if (name === 'DELETE_ACCOUNT') return <TrashCan color={theme.colors.surface} />;
  return null;
}

export default memo(Svgs);
